import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import type { TerritoryStore } from "./territories";
import type { Accessory, BuyingGroupMeta, Channel, Motor, QuoteAccessoriesRecord, Role, SalesPerson, TermsOptions, Tube, loadStatusType } from "../../powershadesApiTypes";
import type { DealerStore } from "./organizations/dealers";
import type { DistributorStore } from "./organizations/distributors";
import type { RepresentativeStore } from "./organizations/representatives";
import type { AddressStore } from "./addresses";
import type { FabricStore, OutdoorFabricStore } from "./fabrics";
import type { AddressStateStore } from "./addressStates";
import { QuoteState } from "./quotes/types";
import { DistributorLocationStore } from "./organizations/types";
import { ManufacturerStore, RMAType, UserStore } from "./types";
import { AssemblyStore } from "./assemblies/types";


const loadStatus = {
	notLoaded: 1 as loadStatusType,
	needsLoaded: 2 as loadStatusType,
	loading: 3 as loadStatusType,
	metaLoaded: 4 as loadStatusType,
	fullyLoaded: 5 as loadStatusType
};

type EntitiesState = {
    // This is the typscript way of typing a js object so it's reated
    // similiar to a dictionary in c#. This allows for quicket lookups.
    // It's less important when the quote ids are few, but will be helpful
    // as the homepage scales.
    quotes: QuoteState,
    organizations: {
        loadStatus: loadStatusType;
    };
    salespeople: {
        list: SalesPerson[];
        loadStatus: loadStatusType;
    };
    dealers: {
        [key: number]: DealerStore;
        loadStatus: loadStatusType;
    };
    distributors: {
        [key: number]: DistributorStore;
        loadStatus: loadStatusType;
    };
    distributorLocations: {
        [key: number]: DistributorLocationStore;
        loadStatus: loadStatusType;
    };
    representatives: {
        [key: number]: RepresentativeStore;
        loadStatus: loadStatusType;
    };
    users: {
        list: Record<number, UserStore>;
        roles: {
            loadStatus: loadStatusType;
            list: Record<number, Role>;
        };
        loadStatus: loadStatusType;
    };
    territories: {
        list: TerritoryStore[];
        loadStatus: loadStatusType;
    };
    // Getting a little weird here. Go to assemblies.ts for an explanation TLDR: 
    //    assemblies[quote_id][sequence_id]
    assemblies: Record<number, Record<number, AssemblyStore>>;
    // //quoteAccessories[quote_id][accessory_id]
    // quoteAccessories: { [key: number]: { [key: number]: QuoteAccessoryStore } },
    // //hardwareRequests[quote_id][line_number]
    // hardwareRequests: { [key: number]: { [key: number]: HardwareRequestStore } },
    addresses: { [key: number]: AddressStore };
    addressStates:{
        loadStatus : loadStatusType;
        list : AddressStateStore[];
    };
    
    fabrics : {
        loadStatus : loadStatusType;
        list : FabricStore[];
    };
    outdoorFabrics : {
        loadStatus : loadStatusType;
        list : OutdoorFabricStore[];
    };
    // headers: {
    //     loadStatus : loadStatusType,
    //     list: HeaderStore[]
    // },
    // accessories : {
    //     loadStatus: loadStatusType,
    //     list : AccessoryStore[]
    // },
    // QuoteTypes: {
    //     loadStatus: loadStatusType;
    //     list: QuoteType[];
    // };

    termsOptions: {
        list: TermsOptions[];
        loadStatus: loadStatusType;
    };
    channels: {
        list: Channel[];
        loadStatus: loadStatusType;
    };
    buyingGroups: {
        list: BuyingGroupMeta[];
        loadStatus: loadStatusType;
    };
    manufacturers: {
        loadStatus: loadStatusType;
        list: Record<number, ManufacturerStore>;
    };
    rmaTypes: {
        loadStatus: loadStatusType;
        list: RMAType[];
    };
    accessories:{
        loadStatus : loadStatusType;
        list : Accessory[];
    };
    // quoteAccessories[QuoteId].Items[LineNumber];
    quoteAccessories: Record<number, QuoteAccessoriesRecord>;

    parts: {
        motors:{
            loadStatus : loadStatusType;
            list : Motor[];
        };
        tubes: {
            loadStatus : loadStatusType;
            list : Tube[];
        };
        
    };

};

export type extraEntityReducersFunction = (builder: ActionReducerMapBuilder<EntitiesState>) => void;

export { loadStatus, EntitiesState };
